<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:titulo-modal="tituloModalEdicao"
			:subtitulo-modal="subtituloModalEdicao"
			@confirmar="acaoConfirmarEdicaoRevisao"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>

<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-editar-revisao',
	components: { ModalConfirmacao },
	props: {
		exibir: Boolean,
	},
	emits: ['fechar-modal', 'confirmar-edicao-revisao'],
	data() {
		return {
			tituloModalEdicao:
				'Atenção! Ao entrar no modo edição, a revisão ficará suspensa do fluxo até sua conclusão',
			subtituloModalEdicao: 'Deseja realmente confirmar esta ação?',
		}
	},
	methods: {
		acaoConfirmarEdicaoRevisao() {
			this.$emit('confirmar-edicao-revisao')
		},
	},
}
</script>

<style scoped lang="stylus"></style>
